import {
    createContext,
    useContext,
    useEffect
} from "react";
import type {
    TableSectionContextType,
    TableRowContextType,
    TableContextType
} from "./type";
import {
    warnOnce
} from "../../utils/development";

export const TableContext = createContext<TableContextType | undefined>(undefined);

export const TableSectionContext = createContext<TableSectionContextType>({
    section: "body",
    isLast: false
});

export const TableRowContext = createContext<TableRowContextType>({
    isDisabled: false,
    isSelected: false,
    isHovered: false,
    isPressed: false,
    columnIndex: 0
});

export const useTableContext = ({
    part
}: {
    part: string;
}): TableContextType | undefined => {
    const context = useContext(TableContext);

    useEffect(() => {
        if(context) {
            return;
        }

        warnOnce({
            message: `Table.${part}: must be rendered inside <Table>.`
        });
    }, [
        context,
        part
    ]);

    return context;
};
